import React from 'react';
import Button from '../Button';
export default function factoryButton(BtnComp, variant) {
    const Component = (props, ref) => {
        return React.createElement(Button, Object.assign({ _BtnComp: BtnComp, _variant: variant }, props, { forwardedRef: ref }));
    };
    return React.forwardRef(Component);
}
//# sourceMappingURL=factoryButton.js.map